/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Iframe_Remote_Qc_Completed_MessageInputs */



/**
* | output |
* | --- |
* | "QC completed: {count} error(s) found" |
*
* @param {Iframe_Remote_Qc_Completed_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_qc_completed_message = /** @type {((inputs: Iframe_Remote_Qc_Completed_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Qc_Completed_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`QC terminee : ${i?.count} erreur(s) trouvee(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Qualitätskontrolle abgeschlossen: ${i?.count} Fehler gefunden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Controllo qualità completato: ${i?.count} errore(i) trovato(i)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Контроль качества завершен: ${i?.count} обнаружены ошибки.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Control de calidad completado: se encontraron ${i?.count} errores`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`质控完成：发现${i?.count}个错误`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`QC 完了: ${i?.count} 件のエラーが見つかりました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`QC पूर्ण हुआ: ${i?.count} त्रुटि पाई गई`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Controle de qualidade concluído: ${i?.count} erro(s) encontrado(s)`)
	return /** @type {LocalizedString} */ (`QC completed: ${i?.count} error(s) found`)
});